import {
  RequestFile,
  DownloadFile,
  Request,
  openDownloadedFileInNewTab
} from "./HttpService";
import { showError } from "./ModalService";

const FileService = {
  upload: function (file, url) {
    const formData = new FormData();

    formData.append("file", file, file.name);
    return RequestFile(url, formData);
  },

  uploadDocument: function (document, url) {
    const formData = new FormData();
    formData.append("documentTypeId", document.documentTypeId);
    formData.append("languageId", document.languageId);
    formData.append("interviewId", document.interviewId);
    formData.append("file", document.file, document.fileName);
    return RequestFile(url, formData);
  },
  uploadBase64: function (filebase64, url) {
    return Request(url, "POST", filebase64);
  },

  multiUpload(files, url) {
    const formData = new FormData();
    for (let file of files) {
      formData.append("files", file, file.name);
    }
    return RequestFile(url, formData);
  },

  Download: function (url, fileName, openInNewTab = false, file) {
    let method = "GET";
    if (file) {
      method = "POST";
    }
    return DownloadFile(url, method, file).then((response) => {
      if (response.ok) {
        response.blob().then((blob) => {
          if (openInNewTab && blob.type === "application/pdf") {
            openDownloadedFileInNewTab(blob, fileName);
          } else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = fileName;
            link.href = url;
            document.body.append(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        });
      } else {
        response.json().then((error) => showError(error.message.text));
      }
    });
  },

  DownloadWithPost: function (url, fileName, data) {
    DownloadFile(url, "POST", data).then((response) => {
      if (response.ok) {
        response.blob().then((blob) => {
          if (blob.type === "application/pdf")
            openDownloadedFileInNewTab(blob, fileName);
          else {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = fileName;
            link.href = url;
            document.body.append(link);
            link.click();
            link.parentNode.removeChild(link);
          }
        });
      } else {
        response.json().then((error) => showError(error.message.text));
      }
    });
  },

  deleteFile(fileName, url) {
    return Request(url + "/" + fileName, "DELETE");
  },
  DownloadFileBase64: function (url, toFileSystem) {
    Request(url, "GET").then(async (data) => {
      if (!data.error) {
        let base64res = await fetch(
          `data:${data.mimeType};base64,${data.base64}`
        );
        base64res.blob().then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          if (toFileSystem) link.download = data.fileName;
          else link.setAttribute("target", "_blank");

          document.body.append(link);
          link.click();
          link.parentNode.removeChild(link);
        });
      }
    });
  },
  convertToDocOnline: function (form) {
    const url = "vitae/file/convert";
    return Request(url, "POST", form);
  }
};
export default FileService;
